/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployerForm/Email",
  isInvalid,
  onChange
  
}) {
let employerContactEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'employer',
path: 'contact_email.address',
})
let employerContactEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'employer',
path: 'contact_email.address',
validate: fromValidate.email,
})
let employerContactEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'employer',
path: 'contact_email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="employer.contact_email.address"
 validate="/Data/validate.js email"
 invalid={!employerContactEmailAddressIsValidData}
 value={employerContactEmailAddressValueData}
 onChange={employerContactEmailAddressChangeData}
 type="email"
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}